import React, {Component} from "react";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import withFormGroup from "../../../modules/commons/withFormGroup";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import {ACTIVITY_TYPE} from "../../common/Constants";

class MasterBankModifying extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cabangOptions: [],
        };
    }

    componentDidMount() {
        this.setState((prevValue) => ({
            ...prevValue,
            cabangOptions: this.props.cabangOptions,
        }));
    }

    handleSubmit = (e) => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    handleReset = () => {
        if (this.props.activity === "Edit") {
            this.props.resetIgnoreKeys(["id"])
        } else {
            this.props.reset();
        }
    };

    render() {
        const {errors} = this.props;
        return (
            <SimpleModal
                title={`${this.props.activity} Bank`}
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <SimpleInput
                            id="input_text_kode_bank"
                            name="id"
                            label="Kode Bank"
                            mandatory
                            readOnly={this.props.activityType === ACTIVITY_TYPE.UPDATE}
                            errorMessage={errors.id}
                            value={this.props.controls.id.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_nama_bank"
                            name="bankName"
                            label="Nama Bank"
                            mandatory
                            errorMessage={errors.bankName}
                            value={this.props.controls.bankName.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_account_number"
                            name="accountNumber"
                            label="No Rekening"
                            mandatory
                            errorMessage={errors.accountNumber}
                            value={this.props.controls.accountNumber.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleInput
                            id="input_text_account_name"
                            name="accountName"
                            label="Nama Rekening"
                            mandatory
                            errorMessage={errors.accountName}
                            value={this.props.controls.accountName.value}
                            onChange={({target}) =>
                                this.props.setValue(target.name, target.value)
                            }
                        />
                        <SimpleDDL
                            id="select_options_untuk_cabang"
                            name="kodeCabang"
                            label="Untuk Cabang"
                            box="multiselect"
                            mandatory
                            errorMessage={errors.kodeCabang}
                            options={this.state.cabangOptions}
                            value={this.props.controls.kodeCabang.value}
                            onChange={(value, {name}) => this.props.setValue(name, value)}
                        />
                        <div style={{textAlign: "center"}}>
                            <SimpleButton
                                type="button"
                                secondary
                                onClick={this.handleReset}
                            >
                                Hapus
                            </SimpleButton>
                            <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                        </div>
                    </ModalContainer>
                }
            />
        );
    }
}

export default withFormGroup(MasterBankModifying);
